import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';

import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import QuickActions from './components/QuickActions';
import Sessions from './components/Sessions';
import ExperienceSection from './components/ExperienceSection';
import CommunitySection from './components/CommunitySection';
import VenueDetails from './components/VenueDetails';
import DaysOut from './components/DaysOut';
import Schools from './components/Schools';
import Pricing from './components/Pricing';
import Facilities from './components/Facilities';
import FAQ from './components/FAQ';
import BookingCalendar from './components/BookingCalendar';
import Location from './components/Location';
import Footer from './components/Footer';

import BookingSuccess from './pages/BookingSuccess';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CancellationPolicy from './pages/CancellationPolicy';

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <Features />
    <CommunitySection />
    <VenueDetails />
    <Facilities />
    <BookingCalendar />
    <Location />
    <Footer />
  </>
);

const YoungDriversPage = () => (
  <>
    <Header />
    <Sessions />
    <ExperienceSection />
    <QuickActions />
    <VenueDetails />
    <DaysOut />
    <Schools />
    <Pricing />
    <Facilities />
    <FAQ />
    <BookingCalendar serviceLine="young_drivers" />
    <Location />
    <Footer />
  </>
);

const DriveWithConfidencePage = () => (
  <>
    <Header />

    <main>
      <section className="relative bg-gradient-to-br from-[hsl(195,100%,12%)] to-[hsl(210,100%,10%)] overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <img
            src="/redesign/new-09.png"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute inset-0 bg-gradient-to-l from-[hsl(195,100%,12%)]/90 via-[hsl(195,100%,12%)]/60 to-transparent" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 lg:py-24">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1 relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-teal-500/20 to-cyan-500/20 rounded-3xl blur-2xl" />
              <img
                src="/redesign/new-10.png"
                alt="Adult driving confidence"
                className="relative rounded-2xl shadow-2xl border-4 border-teal-500/20"
              />
            </div>

            <div className="order-1 lg:order-2">
              <div className="inline-flex items-center gap-2 bg-teal-500/20 backdrop-blur-sm border border-teal-400/30 px-4 py-2 rounded-full text-teal-300 font-bold text-sm mb-5">
                <span>🚗</span>
                <span>DRIVE WITH CONFIDENCE</span>
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
                Build Confidence Behind The Wheel
              </h1>

              <p className="text-xl text-teal-200 font-semibold mb-4">
                For experienced, returning and older drivers.
              </p>

              <p className="text-lg text-white/80 mb-8 leading-relaxed">
                A supportive off-road driving experience designed to help you refresh your skills, rebuild confidence and feel comfortable behind the wheel.
              </p>

              <button
                onClick={() => {
                  document.getElementById('book')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-4 bg-teal-500 hover:bg-teal-400 text-[hsl(210,100%,12%)] font-black text-lg rounded-xl transition-all shadow-xl shadow-teal-500/50 hover:shadow-2xl hover:scale-105"
              >
                BOOK DRIVE WITH CONFIDENCE
              </button>
            </div>
          </div>
        </div>
      </section>

      <VenueDetails />
      <Facilities />
      <BookingCalendar serviceLine="drive_with_confidence" />
      <Location />
    </main>

    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route
            path="/young-drivers"
            element={<YoungDriversPage />}
          />

          <Route
            path="/drive-with-confidence"
            element={<DriveWithConfidencePage />}
          />

          <Route path="/booking-success" element={<BookingSuccess />} />
          <Route path="/booking-cancelled" element={<YoungDriversPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
        </Routes>

        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
